import React from "react";
import PropTypes from "prop-types";
import { H4, Paragraph, Text } from "components/core/Typography";
import { StarRating } from "components/review/StarRating";

function ReviewCard({ heading, description, rating, customCard = false }) {
	const customClass = customCard ? "custom-card" : "review-card";
	return (
		<div className={customClass}>
			{customCard ? (
				<>
					<Text
						size="medium"
						weight="bold"
						color="white"
					>
						{heading}
					</Text>
					<Paragraph color="white">{description}</Paragraph>
				</>
			) : (
				<>
					<H4>{heading}</H4>
					<Text
						color="gray"
						size="small"
						className="rating-stars"
					>
						<StarRating
							rating={rating.stars}
							outOf={5}
						/>
						<span className="name">by {rating.name}</span>
					</Text>

					<Paragraph>{description}</Paragraph>
				</>
			)}
		</div>
	);
}

ReviewCard.propTypes = {
	heading: PropTypes.string,
	description: PropTypes.string,
	rating: PropTypes.object,
	customCard: PropTypes.bool
};

export default ReviewCard;
